import { useMemo } from 'react';
import { Table } from 'ui/table';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { UPDATE_CATALOG_ITEM_METHOD } from 'modules/catalogTable/constants';
import { Body2, BoldText } from 'ui/theme';
import { NEW_FIELDS_TABLE_COLUMNS_JSON, NEW_FIELDS_TABLE_COLUMNS_FILE } from '../constants';
import type { NewFieldTableRow } from '../types';

type NewFieldsTableProps = {
  rowData: NewFieldTableRow[];
  updateMethod: string;
};

export const NewFieldsTable = ({ rowData = [], updateMethod }: NewFieldsTableProps) => {
  const columns = useMemo(() => {
    return updateMethod === UPDATE_CATALOG_ITEM_METHOD.JSON
      ? NEW_FIELDS_TABLE_COLUMNS_JSON
      : NEW_FIELDS_TABLE_COLUMNS_FILE;
  }, [updateMethod]);

  return (
    <div>
      <Body2>
        <BoldText>{rowData.length} new fields</BoldText> found in{' '}
        {updateMethod === UPDATE_CATALOG_ITEM_METHOD.JSON ? 'payload' : 'file'}
      </Body2>
      <Table>
        <TableHeader columns={columns} />
        <TableRows rows={rowData} columns={columns} />
      </Table>
    </div>
  );
};
